import { useSearchParams } from 'react-router-dom';

export function useQueryParam(key, defaultValue) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) ?? defaultValue;

  const setValue = (next) => {
    const sp = new URLSearchParams(searchParams);
    if (next === undefined || next === null || next === '') sp.delete(key);
    else sp.set(key, String(next));
    setSearchParams(sp);
  };

  return [value, setValue];
}
